import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import GridView from "../../commonComponents/gridView";

const CarLeftListContainer = () => {

  return (
    <>
      <Breadcrumbs title="Inventory" url={routes.Home.CarDemo1} mainClass="car-breadcrumbs-section page-breadcrumbs-section-inventory" />
      <GridView side="no" type="car" gridType="list-view" gridSize={1} sectionClass="car-shop-section car-product-section" filterTagsClass="car-list-header" />
    </>
  );
};

export default CarLeftListContainer;
